import { render } from "./RdModal.vue?vue&type=template&id=24cca532&scoped=true"
import script from "./RdModal.vue?vue&type=script&lang=js"
export * from "./RdModal.vue?vue&type=script&lang=js"

import "./RdModal.vue?vue&type=style&index=0&id=24cca532&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24cca532"]])

export default __exports__